// src/track.js — usage tracking for the validation test.
// Fire-and-forget; never blocks the UI or throws.
const API = import.meta.env.VITE_API_URL || "";

function getSession() {
  try {
    let s = localStorage.getItem("cwg_session");
    if (!s) {
      s = (crypto.randomUUID && crypto.randomUUID())
          || Date.now() + Math.random().toString(16).slice(2);
      localStorage.setItem("cwg_session", s);
    }
    return s;
  } catch { return "no-storage"; }
}

// Captured ONCE at load, before the app rewrites the URL for sharing.
const _p = new URLSearchParams(window.location.search);
const SRC = _p.get("src") || "direct";
// arrived_prefilled = user opened someone else's shared link (trip already in URL).
// This app encodes trip state as base64url JSON under the `t` query param
// (see src/lib/shareUrl.js + App.jsx tripFromUrl), so detect that exact param.
const ORIGIN = _p.get("t") ? "arrived_prefilled" : "generated_here";
// document.referrer = the page that sent the visitor here (external site, or
// empty for direct/bookmark visits). NOT window.location.href — that's this
// page's own URL, which the backend used to fall back to via the HTTP Referer
// header on this same-origin fetch (always itself). Captured once at load,
// same as SRC/ORIGIN, before any client-side history rewrite.
const REFERRER = document.referrer || "";

export function track(event, extra = {}) {
  try {
    fetch(`${API}/api/track`, {
      method: "POST",
      keepalive: true,                            // survives the tab navigating away
      headers: { "Content-Type": "text/plain" },  // text/plain = no CORS preflight
      body: JSON.stringify({
        event,
        session: getSession(),
        origin: ORIGIN,
        src: SRC,
        referrer: REFERRER,
        ...extra
      }),
    }).catch(() => {});
  } catch { /* never break the UI */ }
}
